import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostRechnungRunterzaehlenCommandServiceModule } from '..';
import { PostRechnungRunterzaehlenCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostRechnungRunterzaehlenCommandServiceModule
  ],
  declarations: [PostRechnungRunterzaehlenCommandComponent],
  exports: [PostRechnungRunterzaehlenCommandComponent],

})
export class PostRechnungRunterzaehlenCommandComponentModule { }
